import { useEffect } from 'react';

const useDebugRender = (componentName, details) => {
    useEffect(() => {
        if (details) {
            console.log(`[SSO Mount] ${componentName}`, details);
        } else {
            console.log(`[SSO Mount] ${componentName}`);
        }
    }, []);
};

export default useDebugRender;
